import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { copyTextToClipboard } from '../utils/utilities';
import { showSuccessToast } from './ToastMessage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCheck } from '@fortawesome/free-solid-svg-icons';
import './CopyComponent.scss';
import clsx from 'clsx';

interface Props {
	value?: string;
	title?: string;
	withText?: boolean;
	withIcon?: boolean;
	additionalClass?: string;
	childrenAdditionalClass?: string;
	enableCopyText?: boolean;
	children?: string;
}

export const CopyComponent = (props: Props): React.ReactElement => {
	const { t } = useTranslation();
	const { value, title, withText, withIcon = true, additionalClass, childrenAdditionalClass, enableCopyText, children } = props;
	const [isCopied, setIsCopied] = useState<boolean>(false);

	const handleClick = (): void => {
		setIsCopied(true);
		setTimeout(() => setIsCopied(false), 1500);
		copyTextToClipboard(value ? value : children);
		showSuccessToast(`${title} ${t('API_KEY.TOAST_MESSAGE')}`);
	};

	return (
		<div
			className={clsx( 'd-flex align-items-center',
				withText && 'copy-icon w-55px',
				withIcon && 'copy-icon-hover',
				additionalClass,
				isCopied ? 'cursor-not-allowed' : 'cursor-pointer'
			)}
			onClick={(): void => !isCopied && handleClick()}
		>
			{enableCopyText && (
				<div className={childrenAdditionalClass}>{children}</div>
				)}
			{withIcon && <FontAwesomeIcon icon={isCopied ? faCheck : faCopy} />}
			{
				withText && (
					<span className="fw-bolder fs-6 ms-2">
		        {t('SENSE_JS.COPY')}
		      </span>
				)
			}
		</div>
	);
};
